import { useState, useRef } from "react";

import api from "@helpers/api";

import * as Mui from "@mui/material";
import { KeyboardArrowRightRounded } from "@mui/icons-material";

import CustomModal from "@components/CustomModal";

import Parser from "@helpers/parser";

import "./styles.css";

export default function GiveUserAccessToSubscription({ modalRef }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [plansAvailable, setPlansAvailable] = useState([]);

    const REF_config = useRef({});
    const REF_callback = useRef();

    modalRef.current = {
        open(user, community, callback = () => { }) {
            REF_config.current = { user, community };
            REF_callback.current = callback;
            setOpen(true);
            setLoading(true);
            loadPlans(community);
        },
    };

    async function loadPlans(communityId) {
        try {
            const url = `community/plan?community=${communityId}`;
            const { data } = await api.get(url);
            setPlansAvailable(data || []);
        } catch (e) {
            console.error("Erro ao carregar planos:", e);
            window.setSnackbar("Erro ao carregar planos disponíveis");
        } finally {
            setLoading(false);
        }
    }

    function handlePlanSelect(plan) {
        // Calcula a quantidade de dias baseado no intervalo do plano
        const intervalDays = {
            week: 7,
            month: 30,
            bimonthly: 60,
            quarterly: 90,
            semiannual: 180,
            year: 365,
        };

        const daysToAdd = intervalDays[plan.interval] || 30;

        window.openConfirm({
            title: "Confirmar acesso",
            headline: "Deseja confirmar o acesso ao plano?",
            subtitle: `Deseja confirmar o acesso ao plano "${plan.label}" por ${daysToAdd} dias?`,
            buttons: [
                {
                    text: "Cancelar",
                    variant: "text",
                    onClick: () => { },
                },
                {
                    text: "Confirmar acesso",
                    variant: "contained",
                    color: "primary",
                    onClick: async () => {
                        try {
                            await api.post("subscription/enable", {
                                plan: plan.id,
                                subscriber: REF_config.current.user.id,
                            });

                            window.setSnackbar("Assinatura habilitada com sucesso");
                            setOpen(false);
                            REF_callback.current();
                        } catch (error) {
                            console.error("Erro ao habilitar assinatura:", error);
                            window.setSnackbar("Erro ao habilitar assinatura");
                        }
                    },
                },
            ],
        });
    }

    function PlanItem({ plan }) {
        return (
            <div
                className="plan-item pressable"
                onClick={() => handlePlanSelect(plan)}
            >
                <div className="give-access-plan-info-row">
                    <span className="plan-label bold">{plan.label}</span>
                    <span className="plan-label">• {Parser.interval.adjective(plan.interval)}, (R${Parser.price.brl(plan.price)})</span>
                </div>
                <KeyboardArrowRightRounded />
            </div>
        );
    }

    function PlanLoading() {
        return (
            <div className="plan-item" style={{ marginTop: "8px" }}>
                <Mui.Skeleton variant="rectangular" width="100%" height={60} />
            </div>
        );
    }

    return (
        <CustomModal
            maxWidth={350}
            bottomButtonCancelText="Fechar"
            loading={loading}
            title="Selecionar plano"
            open={open}
            handleClose={() => setOpen(false)}
            bodyComponent={
                open ? (
                    <div className="px-4 py-2">
                        {loading ? (
                            <>
                                {["", "", ""].map((_, i) => (
                                    <PlanLoading key={i} />
                                ))}
                            </>
                        ) : (
                            <>
                                <Mui.Alert severity="warning" className="mb-3">
                                    Ao ativar a assinatura, o usuário terá acesso aos recursos do plano selecionado gratuitamente.
                                </Mui.Alert>

                                <Mui.Divider className="plan-item-divider" />

                                <h4 className="mb-2 bold">Planos disponíveis</h4>

                                {plansAvailable.length > 0 ? (
                                    plansAvailable.map((plan, i) => (
                                        <>
                                            {i !== 0 && (
                                                <Mui.Divider className="plan-item-divider" />
                                            )}
                                            <PlanItem key={plan.id || i} plan={plan} />
                                        </>
                                    ))
                                ) : (
                                    <h4 className="center">Nenhum plano disponível</h4>
                                )}
                            </>
                        )}
                    </div>
                ) : null
            }
        />
    );
}
